import $http from '@/api';

const getMessage = async (id, liveType) => {
  const response = await $http.get(`/api/content/${liveType}/live-message/${id}/editor`);
  return response;
};

const searchMessage = async (filters, liveType) => {
  const response = await $http.post(`/api/content/${liveType}/live-message/search`, filters);
  return response;
};

const createMessage = async (message, liveType) => {
  const response = await $http.post(`/api/content/${liveType}/live-message`, message);
  return response;
};

const updateMessage = async (message, diff, liveType) => {
  const response = await $http.patch(`/api/content/${liveType}/live-message/${message.id}/editor`, diff);
  return response;
};

const deleteMessage = async (message, liveType) => {
  const response = await $http.delete(`/api/content/${liveType}/live-message/${message.id}`);
  return response;
};

export default {
  getMessage,
  searchMessage,
  createMessage,
  updateMessage,
  deleteMessage,
};
